
import React from 'react';
import AMCConstants from "./AMCConstants.js";
import { ROUTER } from "./AMCRouter";
import { ZooNinjaButton } from './ZNinja';
import ZooGenericTrackedButton from './ZooGenericTrackedButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFire, faPlay, faGraduationCap, faHammer, faCocktail, faUserNinja } from '@fortawesome/free-solid-svg-icons'



export default class AMCAboutPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		return (
			<div className="AMCStaticPage AMCAboutPage">
				<h1>Passion, Experience, Skill, Worry, Hope and Dedication</h1>

				<div className="AMCAboutUs">
					<div className="AMCAboutCell">
						<h2>Cornelia Davis</h2>
						<img alt="neli" src="/images/neli.jpg" />
					</div>
					<div className="AMCAboutCell">
						<h2>Michael Davis</h2>
						<img alt="mike" src="/images/mike.jpg" />
					</div>
				</div>
				<div className="AMCAboutDetails">
					<h3>80+ years experience</h3>
					<h4>CAD, CHI, UX, Rich GUI (design and study), Math, Applied Math, Methodologies and Business Processes (design and study), Frameworks and Architectures (design and study), Applications/Client Server/Cloud, Tools, OS (build and consume), SysAdmin, AI, ML, DL, B2B, B2C</h4>
				</div>
				<div className="AMCAboutUs">
					<div className="AMCAboutCell">
						<h2>... and superpowered Engineers and Scientists <em>everywhere</em></h2>
						<img alt="worried" src="/images/worried.jpg" />
						<img alt="worried" src="/images/worried.jpg" />
						<img alt="worried" src="/images/worried.jpg" />
					</div>
				</div>
				<div className="AMCAboutDetails">
					<h3>~50 million years of experience</h3>
				</div>

			</div>

		);
	}
}



// WEBPACK FOOTER //
// ./src/AMCAboutPage.js